import { useQuery } from "@tanstack/react-query"
import { Enums } from "config"
import { API } from "config"

const useReport = (report, period = Enums.Period.LAST_7_DAYS) => useQuery({ queryKey: ['report', report, period], queryFn: async () => {
    const callback = await API.get(`/reports/${report}?period=${period}`)
    return callback?.data
}, staleTime: 1000 * 60 * 60, gcTime: 1000 * 60 * 60 * 24})

export default useReport